import type { ReactNode } from 'react'

export default function MainContent({
	children,
	showAside = true,
}: {
	children: ReactNode
	showAside?: boolean
}) {
	const base = 'bg-background flex w-full items-start justify-center p-4 pt-8 lg:items-center'
	const lgWidth = showAside ? 'lg:w-2/3' : 'lg:w-full'
	const className = `${base} ${lgWidth}`

	return (
		<div className={className}>
			<div className="flex w-full max-w-lg flex-col gap-4">{children}</div>
		</div>
	)
}
